import React, { useState } from "react";
import { Facebook, Instagram, Mail, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { toast } from "../hooks/use-toast";
import Logo from "./Logo";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, {
        email: email
      });
      
      toast({
        title: "¡Suscripción exitosa!",
        description: "Gracias por suscribirte a nuestro newsletter.",
      });
      setEmail("");
    } catch (error) {
      if (error.response?.status === 400) {
        toast({
          title: "Email ya registrado",
          description: "Este email ya está suscrito a nuestro newsletter.",
          variant: "destructive"
        });
      } else {
        toast({
          title: "Error",
          description: "No se pudo completar la suscripción. Intenta nuevamente.",
          variant: "destructive"
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1 - Brand */}
          <div>
            <Logo variant="light" className="mb-4" />
            <p className="text-gray-400 mb-4">Quality</p>
            <p className="text-gray-400 leading-relaxed">
              Your satisfaction is our top priority.
            </p>
          </div>

          {/* Column 2 - Contact */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <a
                href="tel:+13058341149"
                className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
              >
                <Phone size={18} />
                <span>+1 (305) 834-1149</span>
              </a>
              <a
                href="mailto:Hidalgodagneris@gmail.com"
                className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
              >
                <Mail size={18} />
                <span>Hidalgodagneris@gmail.com</span>
              </a>
            </div>
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Facebook size={24} />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <Instagram size={24} />
              </a>
            </div>
          </div>

          {/* Column 3 - Newsletter */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Support</h4>
            <p className="text-gray-400 mb-4">Submit Your Inquiry</p>
            <form onSubmit={handleSubmit} className="space-y-3">
              <Input
                type="email"
                placeholder="Your Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-gray-800 border-gray-700 text-white placeholder:text-gray-500"
                required
              />
              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-50"
              >
                {isSubmitting ? "Enviando..." : "Submit"}
              </Button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>© 2025. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;